import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import supabase from '../lib/supabase';
import ImageWithFallback from './ImageWithFallback';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiUsers, FiCalendar, FiArrowRight } = FiIcons;

const NewsConnections = ({ article }) => {
  const [players, setPlayers] = useState([]);
  const [matches, setMatches] = useState([]);

  useEffect(() => {
    if (!article?.id) return;
    let cancelled = false;
    const load = async () => {
      const [playersResult, matchesResult] = await Promise.all([
        supabase
          .from('news_players_aox1234')
          .select('player:team_members_aox1234(id,name,position,image_url,is_published,is_staff)')
          .eq('news_id', article.id),
        supabase
          .from('news_matches_aox1234')
          .select('match:matches_aox1234(id,date,time,home_team,away_team,tournament,round_label)')
          .eq('news_id', article.id),
      ]);
      if (cancelled) return;
      setPlayers((playersResult.data || []).map((row) => row.player).filter((player) => player && player.is_published !== false && !player.is_staff));
      setMatches((matchesResult.data || []).map((row) => row.match).filter(Boolean));
    };
    load();
    return () => { cancelled = true; };
  }, [article?.id]);

  const teams = Array.isArray(article?.team_categories) ? article.team_categories : [];
  if (!teams.length && !players.length && !matches.length) return null;

  return (
    <div className="mt-8 border-t border-gray-100 pt-6 space-y-5">
      <div className="text-sm font-black uppercase tracking-[0.12em] text-gray-500">Σχετικά με</div>

      {teams.length > 0 && (
        <div className="flex flex-wrap gap-2">
          {teams.map((team) => <span key={team} className="rounded-full bg-primary-50 px-3 py-1.5 text-xs font-black text-primary-700">{team}</span>)}
        </div>
      )}

      {players.length > 0 && (
        <div>
          <div className="mb-3 flex items-center text-sm font-bold text-gray-700"><SafeIcon icon={FiUsers} className="mr-2 h-4 w-4 text-primary-600" />Παίκτριες</div>
          <div className="grid gap-3 sm:grid-cols-2">
            {players.map((player) => (
              <Link key={player.id} to={`/team/player/${player.id}`} className="flex items-center gap-3 rounded-xl border border-gray-200 bg-white p-3 hover:border-primary-200 hover:bg-primary-50/30">
                <div className="h-12 w-12 overflow-hidden rounded-full bg-gray-100"><ImageWithFallback src={player.image_url} alt={player.name} className="h-full w-full object-cover object-top" /></div>
                <div className="min-w-0 flex-1"><div className="truncate font-black text-gray-900">{player.name}</div><div className="truncate text-xs text-gray-500">{player.position || 'Παίκτρια'}</div></div>
                <SafeIcon icon={FiArrowRight} className="h-4 w-4 text-primary-500" />
              </Link>
            ))}
          </div>
        </div>
      )}

      {matches.length > 0 && (
        <div>
          <div className="mb-3 flex items-center text-sm font-bold text-gray-700"><SafeIcon icon={FiCalendar} className="mr-2 h-4 w-4 text-primary-600" />Αγώνες</div>
          <div className="space-y-2">
            {matches.map((match) => (
              <Link key={match.id} to={`/matches/${match.id}`} className="flex items-center justify-between gap-3 rounded-xl border border-gray-200 bg-white px-4 py-3 hover:border-primary-200 hover:bg-primary-50/30">
                <div className="min-w-0"><div className="font-black text-gray-900">{match.home_team} – {match.away_team}</div><div className="mt-1 text-xs text-gray-500">{match.date ? new Date(`${String(match.date).slice(0, 10)}T12:00:00`).toLocaleDateString('el-GR') : ''}{match.time ? ` • ${String(match.time).slice(0, 5)}` : ''}{match.round_label ? ` • ${match.round_label}` : ''}</div></div>
                <SafeIcon icon={FiArrowRight} className="h-4 w-4 flex-shrink-0 text-primary-500" />
              </Link>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default NewsConnections;
